import { create } from 'zustand';
import { AlertStyleType } from '@traceair/tds';
import { ReactNode } from 'react';

export interface AlertData {
  title: string;
  type: AlertStyleType;
  description?: string;
  icon?: ReactNode;
  unclosable?: boolean;
}

interface AlertState {
  alerts: AlertData[];
  addAlert: (alert: AlertData, timeout?: number) => void;
  removeAlert: (alert: AlertData) => void;
}

export const getAlertId = ({ title, description }: AlertData) => {
  return `${title}-${description}`;
};

export const useAlertStore = create<AlertState>((set) => ({
  alerts: [],
  addAlert: (alertData, timeout = 10000) => {
    set((state) => ({
      alerts: [...state.alerts, alertData],
    }));

    if (timeout) {
      setTimeout(() => {
        set((state) => ({
          alerts: state.alerts.filter((a) => getAlertId(a) !== getAlertId(alertData)),
        }));
      }, timeout);
    }
  },
  removeAlert: (alertData) => {
    set((state) => ({
      alerts: state.alerts.filter((a) => getAlertId(a) !== getAlertId(alertData)),
    }));
  },
}));
